import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import serviceEndpoints from '../../../config/serviceEndpoints';
import staticGateway from '../../../config/service';
import { getQueryParams } from '../../../utils/utils';

export const getDashboardDetails = createAsyncThunk(
    '/api/superAdmin/DashboardDetails',
    async (data, { rejectWithValue }) => {
        try {
            const response = await staticGateway.get(`${serviceEndpoints.dashboard}/summary`);
            const { success, message } = response.data;
            if (success) {
                return response?.data;
            }
            return rejectWithValue(message);
        } catch (error) {
            return error.message;
        }
    }
);

export const getBarChart = createAsyncThunk('/api/superAdmin/getBarChart', async (data, { rejectWithValue }) => {
    try {
        const response = await staticGateway.get(`${serviceEndpoints.dashboard}/chart/user?${getQueryParams(data)}`);
        const { success, message } = response.data;
        if (success) {
            return response?.data;
        }
        return rejectWithValue(message);
    } catch (error) {
        return error.message;
    }
});

export const getLineChart = createAsyncThunk('/api/superAdmin/getLineChart', async (data, { rejectWithValue }) => {
    try {
        const response = await staticGateway.get(`${serviceEndpoints.dashboard}/chart/court?${getQueryParams(data)}`);
        const { success, message } = response.data;
        if (success) {
            return response?.data;
        }
        return rejectWithValue(message);
    } catch (error) {
        return error.message;
    }
});

const slice = createSlice({
    name: 'user',
    initialState: {
        dashboardData: {},
        barChartData: {},
        lineChartData: {},
        isLoading: false,
        isBarChartLoading: false,
        isLineChartLoading: false,
    },

    extraReducers: (builder) => {
        builder
            .addCase(getDashboardDetails.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getDashboardDetails.rejected, (state) => {
                state.dashboardData = {};
                state.isLoading = false;
            })
            .addCase(getDashboardDetails.fulfilled, (state, { payload }) => {
                const {
                    summary: { counts },
                } = payload;
                state.isLoading = false;
                state.dashboardData = counts;
            })
            .addCase(getBarChart.pending, (state) => {
                state.isBarChartLoading = true;
            })
            .addCase(getBarChart.rejected, (state) => {
                state.barChartData = {};
                state.isBarChartLoading = false;
            })
            .addCase(getBarChart.fulfilled, (state, { payload }) => {
                state.isBarChartLoading = false;
                state.barChartData = payload?.usersChart;
            })
            .addCase(getLineChart.pending, (state) => {
                state.isLineChartLoading = true;
            })
            .addCase(getLineChart.rejected, (state) => {
                state.lineChartData = {};
                state.isLineChartLoading = false;
            })
            .addCase(getLineChart.fulfilled, (state, { payload }) => {
                state.isLineChartLoading = false;
                state.lineChartData = payload?.courtsChart;
            });
    },
});

export default slice.reducer;
